
<template>
  <div class="declare_fill">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <div class="warning_message">
          <h4>温馨提示：</h4>
          <p>1、为防止填写信息因意外丢失，请每隔5分钟点击“暂存”按钮一次。</p>
          <p>2、部分填报内容，系统会自动提取“企业信息”内数据，如需更新，请通知单位管理员在“企业信息”或“补充信息”内修改。</p>
          <p>3、标记为“必填”的内容，必须填写。</p>
          <p>4、当内容超出时，可采用附件方式，在填写框中注明“见附件**”，或者在“附件清单”中，和其他附件合并成一个文件，上传到“无法填写全部内容的补充附件”中。</p>
        </div>
        <div class="file_first_page">
          <p class="page_subtitle">企业上市补贴资金</p>
          <div class="project_message">
            <p><span>项目编号：</span><span class="add_line">2120009000004</span></p>
            <p><img src="@images/icon/erweima.png" alt=""></p>
          </div>
          <h3>企业上市补助资金申报表</h3>
          <div class="base_message">
            <p><span>申报事项：</span><span class="add_line">企业上市补助资金</span></p>
            <p><span>企业名称：</span><span class="add_line">{{basicInfo.company}}</span></p>
            <p><span>注 册 地：</span><span class="add_line">北京市丰台区</span></p>
            <p><span>申报日期：</span><span class="add_line">{{currentTime}}</span></p>
            <p><span>制表单位：</span><span class="add_line">行政审批服务管理局</span></p>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="附件清单" name="second">
        <div class="warning_message">
          <h4>温馨提示：</h4>
          <p>1、标记为“必备材料”的附件，必须上传。</p>
          <p>2、请按照附件要求，每条记录以一个文件形式上传，如果多个文件则先合并为一个文件（建议DOC或PDF或ZIP格式）后上传。</p>
          <p>3、视频文件不超过2GB，其他类型文件不超过50M，格式为<span>JPG、PNG、DOC、DOCX、WPS、PDF、XLS、XLSX、ZIP</span>格式的文件。</p>
          <p>4、对于大于一页的单个附件，如审计报告等，建议采用PDF格式。</p>
          <p>5、附件材料的复印件或者原件，以扫描或者拍照的形式，确保足够清晰、否则将影响单位信息的审核，直至专项资金的审批拨付。</p>
        </div>
        <div class="table-list">
          <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="title"
              label="附件标题">
            </el-table-column>
            <el-table-column
              prop="desc"
              label="附件描述">
            </el-table-column>
            <el-table-column
              prop="name"
              label="文件名称">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="200">
              <template slot-scope="scope">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  :limit="5"
                  :action="upload.url"
                  :disabled="upload.isUploading"
                  :auto-upload="false"
                  :on-change="handleChange"
                  :on-progress="handleFileProgress"
                  :on-success="handleFileSuccess"
                  :on-exceed="handleFileExceed"
                >
                  <el-link type="primary" :underline="false">上传文件</el-link>
                </el-upload>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="btn-list">
      <el-button type="primary"><a target="_blank" href="https://test.sic-credit.com/huiqitong/aa.pdf">预览</a></el-button>
      <el-button type="info" v-if="activeName === 'first'">填写检查</el-button>
      <el-button type="primary" v-if="activeName === 'second'" @click="checkFill()">填写检查</el-button>
      <el-button type="primary" @click="saveSuccess">暂存</el-button>
      <el-button type="primary" @click="submitApply()">提交申请</el-button>
    </div>
    <el-dialog
      title="填写检查"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose">
      <div class="message">
        <p>验证未通过：<span>1</span>项</p>
        <p><span>附件清单></span><span>申报报告未上传</span><a @click="changeLastPage">请上传</a></p>
      </div>
    </el-dialog>
    <el-dialog
      title="请确认以下信息无误后再提交申请"
      :visible.sync="dialogVisible1"
      width="60%"
      :before-close="handleClose1">
      <div class="project_message">
        <div class="project_message_item">
          <h3>项目信息</h3>
          <p>请确保填写项目信息无误，信息的正确新可以极大提高申报成功率</p>
          <div class="details-message"><p><span>企业名称：</span>{{basicInfo.company}}</p><p><span>项目名称：</span>企业上市补助资金</p></div>
          <div class="view-apply">
            <el-button size="small" type="primary" @click="viewFile">预览申报书</el-button>
            <div slot="tip" class="el-upload__tip" style="display: inline-block;margin-left: 10px">注意：请确认审核书展现无误，避免出现格式错误</div>
          </div>
        </div>
        <div class="project_message_item">
          <h3>联系人信息</h3>
          <p>项目进度信息均发送至此手机号，请确保填写无误</p>
          <div class="details-message"><p><span>联系人：</span>吕梁伟</p><p><span>联系电话：</span>18729928367</p></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose1">返回上一步</el-button>
    <el-button type="primary" @click="submitSureSave">确认提交</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'declareDetail',
  data(){
    return {
      activeName: 'first',
      tableData: [{
        title: '【必备材料】申报报告',
        desc: '加盖公章，原件彩色扫描上传',
        name: ''
      }, {
        title: '【必备材料】企业上市补助资金申请表',
        desc: '加盖公章，原件彩色扫描上传',
        name: ''
      }],
      dialogVisible: false,
      dialogVisible1: false,
      fileList:[],
      upload: {
        // 是否显示弹出层
        open: false,
        // 是否禁用上传
        isUploading: false,
        // 上传的地址
        url: this.mainBaseURL + "/fixedAssetsManagement/importFixedAssets",
      },
      currentTime:'',
      basicInfo:{}
    }
  },
  mounted(){
    this.currentTime = this.GetCurrentTime(0)
    this.basicInfo = JSON.parse(localStorage.getItem('basic'))
  },
  methods:{
    GetCurrentTime(flag) {
      var currentTime = "";
      var myDate = new Date();
      var year = myDate.getFullYear();
      var month = parseInt(myDate.getMonth().toString()) + 1; //month是从0开始计数的，因此要 + 1
      if (month < 10) {
        month = "0" + month.toString();
      }
      var date = myDate.getDate();
      if (date < 10) {
        date = "0" + date.toString();
      }
      var hour = myDate.getHours();
      if (hour < 10) {
        hour = "0" + hour.toString();
      }
      var minute = myDate.getMinutes();
      if (minute < 10) {
        minute = "0" + minute.toString();
      }
      var second = myDate.getSeconds();
      if (second < 10) {
        second = "0" + second.toString();
      }
      if(flag == "0")
      {
        currentTime = year.toString() + "-" + month.toString() + "-" + date.toString(); //返回时间的数字组合
      }
      else if(flag == "1")
      {
        currentTime = year.toString() + "/" + month.toString() + "/" + date.toString() + " " + hour.toString() + ":" + minute.toString() + ":" + second.toString(); //以时间格式返回
      }
      return currentTime;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleOperateClick(row) {
      console.log(row);
    },
    checkFill(){
      this.dialogVisible = true
    },
    saveSuccess(){
      this.$message({
        message: '暂存成功！',
        type: 'success'
      });
    },
    handleClose(){
      this.dialogVisible = false
    },

    changeLastPage(){
      this.dialogVisible = false
    },
    handleClose1(){
      this.dialogVisible1 = false
    },
    submitApply(){
      this.dialogVisible1 = true
    },
    submitSureSave(){
      this.dialogVisible1 = false
      this.$router.push({
        name: "PcmApply",
      });
    },
    viewFile(){
      let basicMessage = JSON.parse(localStorage.getItem('basic'))
      if(basicMessage.phone === "18801119733"){
        window.open('https://test1.sic-credit.com/hqtserver/bb.pdf')
        // location.href = 'https://test1.sic-credit.com/hqtserver/bb.pdf'
      }else{
        window.open('https://test.sic-credit.com/huiqitong/aa.pdf')
        // location.href = 'https://test.sic-credit.com/huiqitong/aa.pdf'
      }

    },
    handleChange(file, fileList){
      this.tableData = [{
        title: '【必备材料】申报报告',
        desc: '加盖公章，原件彩色扫描上传',
        name: ''
      }, {
        title: '【必备材料】企业上市补助资金申请表',
        desc: '加盖公章，原件彩色扫描上传',
        name: '企业上市补助资金申请表'
      }]
    },
    handleFileSuccess(response, file, fileList) {
      console.log(response, file, fileList)
      if (response.code == "00000") {
        this.upload.open = false;
        this.upload.isUploading = false;
        this.$refs.upload.clearFiles();
        this.importOpen = true;
        this.importData = response.data.errorList;
        this.importSucceedNumber = response.data.succeedNumber;
        this.importErrorNumber = response.data.errorNumber;
        this.getList();
        this.$message.success('上传成功');
      } else {
        this.upload.isUploading = false;
        this.$refs.upload.abort();
        this.$message.error(response.msg);
      }
      console.log(333)
    },
    handleFileProgress(event, file, fileList) {
      console.log(event, file,  fileList)
      this.upload.isUploading = true;
      console.log(444)
    },
    handleFileExceed(response) {
      this.$alert("只能上传五个文件");
      console.log(555)
    },
  }
}
</script>

<style lang="scss" scoped>
.declare_fill{
  width: 100%;
  margin: 20px auto;
  /deep/ .el-tabs{
    width: 100%;
  }
  .warning_message{
    p{
      padding-left: 15px;
      color: #666666;
      font-size: 14px;
      span{
        color: rgb(249, 84, 17);
      }
    }
  }
  .file_first_page{
    width: 80%;
    margin: 40px auto;
    .page_subtitle{
      border-bottom: 1px solid #666666;
      text-align: right;
      padding-bottom: 10px;
      padding-right: 5%;
    }
    .project_message{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 200px;
      padding: 0 5%;
      p{
        &:first-child{
          .add_line{
            display: inline-block;
            margin: 3px 5px;
            text-decoration: underline;
          }
        }
      }
    }
    h3{
      text-align: center;
      font-size: 28px;
      margin: 80px 0 200px;
    }
    .base_message{
      width: 100%;
      margin-bottom: 150px;
      p{
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
        span{
          display: flex;
          justify-content: center;
          &:first-child{
            flex: 2;
            justify-content: flex-end;
          }
          &.add_line{
            flex: 3;
            justify-content: flex-start;
            margin-bottom: 3px;
            position: relative;
            &::after{
              position: absolute;
              width: 60%;
              height: 1px;
              left: 0;
              bottom: -4px;
              background-color: #666666;
              content: '';
            }
          }
        }

      }
    }
  }
  .btn-list{
    width: 100%;
    display: flex;
    justify-content: center;
    .el-button{
      a{
        text-decoration: none;
        color: #ffffff;
      }

    }
  }
  /deep/ .el-upload-list{
    display: none;
  }
  .table-list{
    margin: 20px 0 100px 0;
  }
  .el-dialog{
    .el-dialog__body{
      .message{
        margin-bottom: 30px;
        p{
          span{
            color: rgb(249, 84, 17);
            &:nth-child(2){
              margin-right: 10px;
            }
          }
          a{
            color: rgb(249, 84, 17);
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
      .project_message{
        .project_message_item{
          h3{
            color: #333333;
          }
          &:first-child{
            margin-bottom: 50px;
          }
          .details-message{
            display: flex;
            p{
              width: 50%;
            }

          }
        }
      }
    }
  }
}
@media only screen and (max-width:1440px) {
  .declare_fill{
    width: 1200px;

  }
}

</style>